window.$ = window.jQuery = require('jquery');

// npm plugins
require('bootstrap/dist/js/bootstrap.min');
require('vgnav/dist/js/vgnav.min');
require('jgrowl/jquery.jgrowl');

// local plugins
require('../../vendor/cookie/jquery.cookie');
require('../../vendor/owl/owl.carousel');
require('../../vendor/m-aim/jquery.menu-aim');
require('../../vendor/fancybox/jquery.fancybox');
require('../../vendor/inputMask/jquery.inputmask');
require('../../vendor/nice-select/jquery.nice-select');
require('../../vendor/vegas/sidebar/jquery.vegasSidebar');
require('../../vendor/vegas/dropdown/jquery.vegasDropdown');
require('../../vendor/vegas/load-async/jquery.vegasLoadAsync');
require('../../vendor/vegas/cnt-el/jquery.vegasCountElements');
require('../../vendor/vegas/scroll-To/jquery.vegasScrollTo');

// functions
require('./functions');

// modules
require('./modules/mMenu');
require('./modules/auth');
require('./modules/cookie');
require('./modules/location/cities');
require('./modules/location/geoLocation');
require('./modules/location/maps');
require('./modules/snowfall');
require('./modules/search');
require('./modules/adult');

// Store
/*require('./modules/store/Store');
require('./modules/store/Basket');
require('./modules/store/Product');
require('./modules/store/WishList');
require('./modules/store/listner');*/

require('./modules/shop/cart');
require('./modules/shop/order');
require('./modules/shop/fav');
require('./modules/shop/images');
require('./modules/shop/review');

require('./modules/vegas');
// [[vegas]]

require('./custom');